module.exports = __webpack_public_path__ + "img/maoEspelhada.b7445f47.png";